import { Component, OnInit } from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {TranslateService} from '@ngx-translate/core';


@Component({
  selector: 'cookie-policy',
  templateUrl: './cookie-policy.component.html'
})
export class CookiePolicyComponent implements OnInit {
  locale: string;
  showCookiePolicy: boolean = false;
  cookieName: string = 'CookiePolicy';
  cookieValue: number = 1;

  constructor(private route: ActivatedRoute, private router: Router, private translate: TranslateService) { }

  ngOnInit() {
    this.locale = window.location.pathname.split('/')[1];
    if (!this.getPolicyCookie()) {
      this.showCookiePolicy = true;
    }

    window.addEventListener('load', () => {this.showCookieOverlay();}, true);

  }

  closeCookiePolicy() {
    var policyElement = document.getElementById('cookie-policy-overlay');
    policyElement.classList.remove("in");
    //policyElement.classList.remove("show-cookie");
    setTimeout(() => {
      policyElement.classList.add("hide");
    }, 300);
    this.setPolicyCookie();
  }

  setPolicyCookie() {
    document.cookie = this.cookieName+'='+this.cookieValue+'; expires=Thu, 01 Jan 2050 00:00:01 GMT; path=/';
  }

  getPolicyCookie(){
    var value = "; " + document.cookie;
    var parts = value.split("; " + this.cookieName + "=");
    if (parts.length == 2) return parts.pop().split(";").shift();
  }

  showCookieOverlay() {
    if(this.showCookiePolicy) {
      var policyElement = document.getElementById('cookie-policy-overlay');
      policyElement.classList.add("in");
      //policyElement.classList.add("show-cookie");
    }
  }

}
